import type { EventPageBroadcast } from '../data/types'
import { truthy } from '../data/types'
import styles from './BroadcastBanner.module.css'

export function BroadcastBanner({ broadcasts }: { broadcasts: EventPageBroadcast[] }) {
  if (!broadcasts.length) return null
  return (
    <div className={styles.stack}>
      {broadcasts.map((b) => (
        <div key={b.id} className={`${styles.banner} ${truthy(b.critical) ? styles.critical : ''}`}>
          {b.title ? <strong>{b.title}: </strong> : null}
          {b.message}
        </div>
      ))}
    </div>
  )
}
